export class CursorUtils {
    static getCursorPosition = (element: HTMLDivElement): number => {
        let cursorOffset = 0;
        const range = window.getSelection().getRangeAt(0);
        const preCursorRange = range.cloneRange();
        preCursorRange.selectNodeContents(element);
        preCursorRange.setEnd(range.endContainer, range.endOffset);
        cursorOffset = preCursorRange.toString().length;
        return cursorOffset;
    }

    static setCursorPosition = (element: HTMLDivElement, position: number, nodeName: string = 'MARK'): void => {
        const range = document.createRange();
        const selection = window.getSelection();

        // tslint:disable-next-line: prefer-for-of
        for (let index = 0; index < element.childNodes.length; index++) {
            const childNode = element.childNodes[index];
            const nodeLength = CursorUtils.calculateNodeLength(childNode);

            if (nodeLength < position) {
                position -= nodeLength;
            } else if (childNode.nodeType === Node.TEXT_NODE) {
                range.setStart(childNode, position);
                break;
            } else if (childNode.nodeName === nodeName) {
                if (!element.childNodes[index + 1]) {
                    element.innerHTML += ' ';
                }

                range.setStart(element.childNodes[index + 1], 0);
                break;
            }
        }

        range.collapse(true);

        selection.removeAllRanges();
        selection.addRange(range);
    }

    static calculateNodeLength = (node: Node): number => {
        if (node.nodeType === Node.TEXT_NODE) {
            return node.textContent.length;
        } else {
            return node.childNodes[0]?.textContent.length;
        }
    }
}
